<app-modal-basic #modalAddEdit id="modalAddEditDonor">
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">{{modalTitle}}</h6>
  </div>
  <div class="app-modal-body modal-padding">
    <table style="width:100%">
      <tr id="validationMsgDonorDlg" style="display: none">
        <td></td>
        <td style="color: red; white-space: pre-wrap" id="validationErrorTdDonorDlg" colspan="3">
          Fields marked with * cannot be blank
        </td>
      </tr>
      <tr>
        <td nowrap>First name *&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.firstName" id="FirstName" maxlength="45" class="form-control" (change)="onNameChanged()" trimOnBlur data-not-blank-donor-dlg>
        </td>
        <td nowrap>Last name *&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.lastName" maxlength="45" class="form-control" (change)="onNameChanged()" trimOnBlur data-not-blank-donor-dlg>
        </td>
      </tr>
      <tr>
        <td nowrap>Address 1&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.address1" maxlength="95" class="form-control" trimOnBlur>
        </td>
        <td nowrap>Address 2&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.address2" maxlength="95" class="form-control" trimOnBlur>
        </td>
      </tr>
      <tr>
        <td nowrap>City&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.city" maxlength="45" class="form-control" trimOnBlur>
        </td>
        <td nowrap>State&nbsp;</td>
        <td>
          <select class="form-control" [(ngModel)]="objectAddEdit.stateOptionNo" id="State" name="State">
            <option value=""></option>
            <option value="-1">Alabama</option>
            <option value="-2">Alaska</option>
            <option value="-3">Arizona</option>
            <option value="-4">Arkansas</option>
            <option value="-5">California</option>
            <option value="-6">Colorado</option>
            <option value="-7">Connecticut</option>
            <option value="-8">Delaware</option>
            <option value="-9">District Of Columbia</option>
            <option value="-10">Florida</option>
            <option value="-11">Georgia</option>
            <option value="-12">Hawaii</option>
            <option value="-13">Idaho</option>
            <option value="-14">Illinois</option>
            <option value="-15">Indiana</option>
            <option value="-16">Iowa</option>
            <option value="-17">Kansas</option>
            <option value="-18">Kentucky</option>
            <option value="-19">Louisiana</option>
            <option value="-20">Maine</option>
            <option value="-21">Maryland</option>
            <option value="-22">Massachusetts</option>
            <option value="-23">Michigan</option>
            <option value="-24">Minnesota</option>
            <option value="-25">Mississippi</option>
            <option value="-26">Missouri</option>
            <option value="-27">Montana</option>
            <option value="-28">Nebraska</option>
            <option value="-29">Nevada</option>
            <option value="-30">New Hampshire</option>
            <option value="-31">New Jersey</option>
            <option value="-32">New Mexico</option>
            <option value="-33">New York</option>
            <option value="-34">North Carolina</option>
            <option value="-35">North Dakota</option>
            <option value="-36">Ohio</option>
            <option value="-37">Oklahoma</option>
            <option value="-38">Oregon</option>
            <option value="-39">Pennsylvania</option>
            <option value="-40">Rhode Island</option>
            <option value="-41">South Carolina</option>
            <option value="-42">South Dakota</option>
            <option value="-43">Tennessee</option>
            <option value="-44">Texas</option>
            <option value="-45">Utah</option>
            <option value="-46">Vermont</option>
            <option value="-47">Virginia</option>
            <option value="-48">Washington</option>
            <option value="-49">West Virginia</option>
            <option value="-50">Wisconsin</option>
            <option value="-51">Wyoming</option>
            <option value="-52">American Samoa</option>
            <option value="-53">Guam</option>
            <option value="-54">Northern Mariana Islands</option>
            <option value="-55">Puerto Rico</option>
            <option value="-56">Virgin Islands</option>
            <option value="-57">Alberta</option>
            <option value="-58">British Columbia</option>
            <option value="-59">Manitoba</option>
            <option value="-60">New Brunswick</option>
            <option value="-61">Newfoundland and Labrador</option>
            <option value="-62">Northwest Territories</option>
            <option value="-63">Nova Scotia</option>
            <option value="-64">Nunavut</option>
            <option value="-65">Ontario</option>
            <option value="-66">Prince Edward Island</option>
            <option value="-67">Quebec</option>
            <option value="-68">Saskatchewan</option>
            <option value="-69">Yukon</option>
          </select>
        </td>
      </tr>
      <tr>
        <td nowrap>Zip code&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.zipCode" id="zipCode" maxlength="6" class="form-control" trimOnBlur>
        </td>
        <td nowrap>Country&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.country" id="country" maxlength="18" class="form-control" trimOnBlur>
        </td>
      </tr>
      <tr>
        <td nowrap>Email&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.email" id="email" maxlength="45" class="form-control" trimOnBlur>
        </td>
        <td nowrap>Phone&nbsp;</td>
        <td>
          <input type="text" [(ngModel)]="objectAddEdit.phone" id="phone" maxlength="18" class="form-control" trimOnBlur mask="(000) 000-0000" [dropSpecialCharacters]="false" [showMaskTyped]="true">
        </td>
      </tr>
      <tr [hidden]="!enableDonorEnvelope">
        <td nowrap>Envelope&nbsp;</td>
        <td style="padding-right: 15px">
          <input type="text" [(ngModel)]="objectAddEdit.envelope" maxlength="13" class="form-control" trimOnBlur>
        </td>
      </tr>
      <tr>
        <td nowrap>Joint donor&nbsp;</td>
        <td nowrap style="padding-right: 15px">
          <b>{{objectAddEdit.jointDonorName}}&nbsp;&nbsp;</b>
          <a href="javascript:void(0);" (click)="changeJointDonor()">(Change joint donor)</a>
        </td>
        <td nowrap>Federal ID&nbsp;</td>
        <td nowrap style="padding-top: 11px;">
          <label><input type="radio" name="FedId" (change)="onFedIdRadioChanged(true)" [checked]="objectAddEdit.hasSSN" style="transform: scale(1.2)">&nbsp; Social security #</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <label><input type="radio" name="FedId" (change)="onFedIdRadioChanged(false)" [checked]="!objectAddEdit.hasSSN" style="transform: scale(1.2)">&nbsp; Employer ID #</label>
        </td>
      </tr>
      <tr>
        <td nowrap style="line-height:1"><span [hidden]="!objectAddEdit.jointDonorNo">Primary joint donor&nbsp;</span></td>
        <td>
          <input id="jointDonorPrimary" type="checkbox" [(ngModel)]="objectAddEdit.jointDonorPrimary" class="big-checkbox" [hidden]="!objectAddEdit.jointDonorNo">
        </td>
        <td></td>
        <td>
          <input type="text" id="federalID" [(ngModel)]="objectAddEdit.federalID" maxlength="20" class="form-control" trimOnBlur [mask]="fedIdMask" [dropSpecialCharacters]="false" [showMaskTyped]="true">
        </td>
      </tr>
      <tr>
        <td nowrap>Active&nbsp;</td>
        <td>
          <input id="DonorActive" type="checkbox" [(ngModel)]="objectAddEdit.donorActive" class="big-checkbox">
        </td>
        <td nowrap>Statements *&nbsp;</td>
        <td style="padding-top:9px" id="statementCell">
          <label><input type="radio" name="Statement" (change)="onStatementRadioChanged(false)" [checked]="objectAddEdit.usePaperStatement === false" style="transform: scale(1.2)">&nbsp; Email</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <label><input type="radio" name="Statement" (change)="onStatementRadioChanged(true)" [checked]="objectAddEdit.usePaperStatement" style="transform: scale(1.2)">&nbsp; Paper</label>
        </td>
      </tr>
    </table>
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="finishAddEditDonor()">Save</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" (click)="cancelAddEditDonor()">Cancel</button>
  </div>
</app-modal-basic>
